import React from "react";
import { CANT_DECIDE, NAILED_IT, NOT_REALLY } from "../../lib/choices";
import { FIRST_QUESTION } from "../../lib/mapping";
import { FirstAnswer } from "../../lib/types";

interface IFirstQuestionProps {
  value: FirstAnswer;
  changeView: () => void;
  setValue: (value: FirstAnswer) => void;
}

/** Display first question */
const FirstQ = ({
  setValue,
  value,
  changeView,
}: IFirstQuestionProps): JSX.Element => {
  /** Allows users to answer using keyboard */
  const handleKeyPress = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "a") {
      setValue(NAILED_IT);
    }
    if (event.key === "b") {
      setValue(CANT_DECIDE);
    }

    if (event.key === "c") {
      setValue(NOT_REALLY);
    }
  };

  /** Select option */
  const optionSelected = (answer: FirstAnswer) => {
    setValue(answer);
  };

  return (
    <section className="first-section">
      <h1 className="first-header">{FIRST_QUESTION}</h1>
      <p>
        Please let us know how satisfied you are with your recent support
        experience?
      </p>
      <section className="choices-section">
        <div className="choices-layout">
          <ul className="choices-list">
            <li className="list-button">
              <button
                type="button"
                className="list-item"
                onClick={() => optionSelected(NAILED_IT)}
                tabIndex={0}
                onKeyPress={(e) => handleKeyPress(e)}
              >
                {value === NAILED_IT ? <div className="selected" /> : null}
                <img
                  className="list-image"
                  alt={NAILED_IT}
                  src="https://images.typeform.com/images/5jx3ihFJXAzt/choice/default"
                />
                <div className="instructions">
                  <p
                    className={`key ${
                      value === NAILED_IT ? "selected-key" : ""
                    }`}
                  >
                    A
                  </p>
                  <p>{NAILED_IT}</p>
                </div>
              </button>
            </li>
            <li className="list-button">
              <button
                type="button"
                className="list-item"
                onClick={() => optionSelected(CANT_DECIDE)}
                tabIndex={0}
                onKeyPress={(e) => handleKeyPress(e)}
              >
                {value === CANT_DECIDE ? <div className="selected" /> : null}
                <img
                  className="list-image"
                  alt={CANT_DECIDE}
                  src="https://images.typeform.com/images/Rm5zqV52mqqa/choice/default"
                />
                <div className="instructions">
                  <p
                    className={`key ${
                      value === CANT_DECIDE ? "selected-key" : ""
                    }`}
                  >
                    B
                  </p>
                  <p>{CANT_DECIDE}</p>
                </div>
              </button>
            </li>
            <li className="list-button">
              <button
                type="button"
                className="list-item"
                onClick={() => optionSelected(NOT_REALLY)}
                tabIndex={0}
                onKeyPress={(e) => handleKeyPress(e)}
              >
                {value === NOT_REALLY ? <div className="selected" /> : null}
                <img
                  className="list-image"
                  alt={NOT_REALLY}
                  src="https://images.typeform.com/images/trG3T7YZ8cRB/choice/default"
                />
                <div className="instructions">
                  <p
                    className={`key ${
                      value === NOT_REALLY ? "selected-key" : ""
                    }`}
                  >
                    C
                  </p>
                  <p>{NOT_REALLY}</p>
                </div>
              </button>
            </li>
          </ul>
        </div>
        {!!value && (
          <button
            className="orange-button"
            tabIndex={0}
            type="button"
            onClick={changeView}
          >
            OK
          </button>
        )}
      </section>
    </section>
  );
};

export default FirstQ;
